// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3GFlJ","active":"NavigationItem_active__3ZIH6"};